import {
  ColumnSettings,
  ColumnTypes,
  TableFilterType,
  ColumnName,
} from '@app/sharedModule/models/table-settings.model';
import { TranslatedFulfillmentStatus } from '@pdqdev/pdq-shared/dist/OrderData';

export const assignColumnsConfig: ColumnSettings[] = [
  {
    type: ColumnTypes.CHECKBOX,
    prop: 'checkbox',
    hideColumnName: true,
    sortable: false,
    width: 35,
    minWidth: 35,
    maxWidth: 35,
    withValidationIconOnAssign: true,
  },
  {
    type: ColumnTypes.COLOR,
    prop: 'colorCoding',
    name: 'Color coding',
    filterType: TableFilterType.COLOR,
    filterOption: 'IN',
    filterValueArray: [],
    sortDirection: null,
    width: 50,
    minWidth: 50,
    maxWidth: 120,
    canBeHide: true,
    default: true,
  },
  {
    type: ColumnTypes.ORDER_NUMBER,
    prop: 'orderNumber',
    name: 'Order no.',
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    fraudRisk: true,
    sortDirection: null,
    unHold: true,
    unSchedule: true,
    pendingPayment: true,
    inventoryOutOfStock: true,
    split: true,
    merged: true,
    canBeHide: true,
    default: true,
    picked: true,
  },
  {
    prop: 'externalOrderNumber',
    name: 'External order number',
    type: ColumnTypes.TEXT,
    width: 50,
    minWidth: 50,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'itemCount',
    name: 'Items',
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    filterType: TableFilterType.NUMBER,
    filterOption: 'IN',
    filterValue: '',
    sortDirection: null,
    default: true,
    canBeHide: true,
  },
  {
    prop: 'zone',
    name: 'Zone',
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    filterType: TableFilterType.NUMBER,
    filterOption: 'IN',
    filterValue: '',
    sortDirection: null,
    default: false,
    canBeHide: true,
  },
  {
    prop: 'createdDate',
    name: 'Date ordered',
    type: ColumnTypes.DATE,
    width: 110,
    minWidth: 90,
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    filterValue: '',
    sortDirection: null,
    lineBreak: true,
    headerTitleIcon: true,
    canBeHide: true,
    default: true,
  },
  {
    prop: 'shippingAddressFormatted',
    name: 'Ship to',
    width: 180,
    minWidth: 180,
    type: ColumnTypes.POPOVER_COLUMN,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    withNote: true,
    sortFieldName: ['customer.ordersCount'],
    withLoyalty: true,
  },
  {
    prop: 'shippingAddress.province',
    name: 'Ship to state',
    width: 120,
    minWidth: 120,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shippingAddress'],
    default: false,
    canBeHide: true,
  },
  {
    prop: 'shippingAddress.country',
    name: 'Ship to country',
    width: 140,
    minWidth: 140,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shippingAddress'],
    default: false,
    canBeHide: true,
  },
  {
    prop: 'customerFormated',
    name: 'Bill to',
    width: 90,
    minWidth: 90,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: null,
    sortFieldName: ['customer.firstName'],
    canBeHide: true,
    default: true,
  },
  {
    prop: 'shipFromAddress.storeName',
    name: ColumnName.INVENTORY_LOCATION,
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.SELECT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shipFromAddress'],
    default: true,
    canBeHide: true,
    filterSelectOptions: [],
  },
  {
    prop: 'deliveryMethod',
    name: 'Delivery method',
    width: 100,
    minWidth: 100,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: null,
    default: true,
    canBeHide: true,
  },
  {
    prop: 'box.name',
    name: 'Package name',
    filterType: TableFilterType.SELECT,
    type: ColumnTypes.POPOVER_COLUMN,
    width: 100,
    minWidth: 100,
    filterOption: 'LIKE',
    filterValue: '',
    default: false,
    sortDirection: '',
    canBeHide: true,
    sortFieldName: ['box.name'],
    filterSelectOptions: [],
  },
  {
    prop: 'totalTagsCount',
    name: 'Tags',
    type: ColumnTypes.POPOVER_COLUMN,
    width: 80,
    minWidth: 80,
    filterType: TableFilterType.TAGS,
    filterOption: 'IN',
    filterValue: '',
    filterValueArray: [],
    default: false,
    sortDirection: '',
    canBeHide: true,
    tooltipText: 'View all tags',
    scrollSection: 'orderTagsId',
    zeroStateText: 'tag',
  },
  {
    prop: 'skus',
    name: `SKUs`,
    filterType: TableFilterType.TEXT,
    type: ColumnTypes.POPOVER_COLUMN,
    width: 100,
    minWidth: 100,
    filterOption: 'LIKE',
    filterValue: '',
    default: false,
    sortDirection: '',
    canBeHide: true,
    sortFieldName: ['skus'],
    tooltipText: 'View all skus',
    scrollSection: 'orderDetailsId',
    zeroStateText: 'SKU',
  },
  {
    prop: 'time_since_ordered',
    name: 'Time since ordered',
    type: ColumnTypes.TEXT,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: 1,
        text: 'under 1 day',
      },
      {
        value: 2,
        text: 'under 2 days',
      },
      {
        value: 3,
        text: 'under 3 days',
      },
      {
        value: 4,
        text: 'under 4 days',
      },
      {
        value: 5,
        text: 'under 5 days',
      },
      {
        value: '> 5',
        text: 'over 5 days',
      },
      {
        value: '> 10',
        text: 'over 10 days',
      },
      {
        value: '> 15',
        text: 'over 15 days',
      },
    ],
    filterOption: 'DATE RANGE',
    filterValue: '',
    width: 100,
    minWidth: 100,
    canBeHide: true,
    filterFields: 'createdDate',
    sortFieldName: ['createdDate'],
    headerInfo: 'Data reflects Calendar days only',
    default: true,
  },
  {
    prop: 'radius',
    name: 'Radius',
    width: 100,
    minWidth: 100,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: '0-10',
        text: '0 - 10',
      },
      {
        value: '10-14',
        text: '10 - 14',
      },
      {
        value: '15-29',
        text: '15 - 29',
      },
      {
        value: '30-99',
        text: '30 - 99',
      },
      {
        value: '100-499',
        text: '100 - 499',
      },
      {
        value: '499-1499',
        text: '499 - 1499',
      },
      {
        value: '1500-2999',
        text: '1500 - 2999',
      },
      {
        value: '3000',
        text: '3000+',
      },
    ],
    filterOption: 'NUMBER RANGE',
    filterValue: '',
    sortDirection: null,
    canBeHide: true,
    default: false,
    displayCondition: (metadata) => {
      return !!metadata?.enableOrderRadiusFeature;
    },
  },
  // {
  //   prop: 'recommendedCarrierProviders',
  //   name: 'Preferred carrier',
  //   type: ColumnTypes.TEXT,
  //   width: 50,
  //   minWidth: 50,
  //   filterType: TableFilterType.SELECT,
  //   filterOption: 'LIKE',
  //   filterSelectOptions: [
  //     {
  //       value: CarrierProvidersNames.FEDEX,
  //       text: 'Fedex',
  //     },
  //     {
  //       value: CarrierProvidersNames.USPS,
  //       text: 'USPS',
  //     },
  //     {
  //       value: CarrierProvidersNames.UPS,
  //       text: 'UPS',
  //     },
  //   ],
  //   filterValue: '',
  //   canBeHide: true,
  //   default: false,
  // },
  // {
  //   prop: 'recommendedServiceLevelNames',
  //   name: 'Preferred service level',
  //   type: ColumnTypes.TEXT,
  //   width: 50,
  //   minWidth: 50,
  //   filterType: TableFilterType.SELECT,
  //   filterValue: '',
  //   canBeHide: true,
  //   default: false,
  // },
  {
    prop: 'selectedRate',
    name: 'Selected service level',
    type: ColumnTypes.SELECTED_RATE,
    width: 50,
    minWidth: 50,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'maximalShippingHours',
    name: 'Maximum transit time (days)',
    type: ColumnTypes.TEXT,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: '<= 1',
        text: 'under 1 day',
      },
      {
        value: '<= 2',
        text: 'under 2 days',
      },
      {
        value: '<= 3',
        text: 'under 3 days',
      },
      {
        value: '<= 4',
        text: 'under 4 days',
      },
      {
        value: '<= 5',
        text: 'under 5 days',
      },
      {
        value: '> 5',
        text: 'over 5 days',
      },
    ],
    width: 50,
    minWidth: 50,
    filterOption: 'LIKE',
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'fulfillmentStatus',
    name: 'Fulfillment status',
    type: ColumnTypes.FULFILLMENT,
    width: 100,
    minWidth: 100,
    maxWidth: 120,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: TranslatedFulfillmentStatus.FULFILLED,
        text: 'Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.PARTIALLY_FULFILLED,
        text: 'Partially Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.NOT_FULFILLED,
        text: 'Unfulfilled',
      },
    ],
    filterOption: 'LIKE',
    sortDirection: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'merchantShippingDate',
    name: 'Ship on',
    type: ColumnTypes.DATE,
    dateFormat: 'MMM dd',
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    width: 110,
    minWidth: 90,
    maxWidth: 200,
    filterFields: 'merchantShippingDate',
    sortFieldName: ['merchantShippingDate'],
    canBeHide: true,
  },

  {
    prop: 'deliveryPromise',
    name: 'Delivery promise',
    type: ColumnTypes.DELIVERY_PROMISE,
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    width: 190,
    minWidth: 190,
    maxWidth: 260,
    filterFields: 'deliveryDate',
    sortFieldName: ['deliveryDate'],
    default: true,
  },
];
